import React, { useEffect } from "react";
import './Login.css';
import { Card } from "react-bootstrap";
import rcmlogo from '../../assets/images/rcmlogo.png';
import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { userlogin, emailcredentials } from "../authService";
import { useAppDispatch } from "../../core/redux/hooks";
import { fetchingUserDetails, setIsAuthenticated, setUserDetails } from "../../core/redux/authSlice";
import { hideToaster, showToaster } from "../../core/redux/toastSlice";

const Login = () => {

    const [email, setEmail] = useState<any>("");
    const [password, setPassword] = useState<any>("");
    const [updatepassmsg, setUpdatepassmsg] = useState("");

    const location = useLocation();
    const dispatch = useAppDispatch();

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        if (name === 'email') {
            setEmail(value);
        }
        if (name === 'password') {
            setPassword(value);
        }
    }
    const navigate = useNavigate();

    const navigateToContacts = () => {
        navigate('/customer');
    };

    const [passwordType, setPasswordType] = useState<string>("password");

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    useEffect(() => {
        if (location.state !== null) {
            setUpdatepassmsg(location.state.message);
        }
    }, [])

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (!email) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Email is required.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            return false;
        } else {
            let pattern = new RegExp(/^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/);
            if (!pattern.test(email.trim())) {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: "Invalid email format.",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
                return false;
            }
        }
        if (!password) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Password is requried.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            return false;
        } else {
            if (!password.match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&!]).*$/)) {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: "Invalid password format.",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
                return false;
            }
        }
        login(email, password);
    }
    const login = (email: any, password: any) => {
        if ((typeof (email) && typeof (password)) !== "undefined") {
            userlogin(email?.toLowerCase().trim(), password.trim()).then((response: any) => {
                dispatch(fetchingUserDetails(true));
                if (response.user.role === "super_admin") {
                    if (response && response.accessToken !== '' && response.accessToken !== null) {
                        dispatch(hideToaster());
                        // console.log(localStorage.getItem('accessToken'), 'login-token');
                        emailcredentials(response.user.email);
                        dispatch(setIsAuthenticated(true));
                        dispatch(setUserDetails({ name: response.user.name, email: response.user.email, role: response.user.role }));
                        dispatch(fetchingUserDetails(false));
                        navigateToContacts();
                    }
                } else {
                    dispatch(showToaster(
                        {
                            dialogBgColor: 'bg-danger',
                            dialogMsg: "You are not authorized",
                            showDialog: true,
                            timer: '5000'
                        }
                    ));
                }
            }).catch((error: any) => {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: error.response.data.message ? error.response.data.message : "Something went wrong",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
            });
        } else {
            console.log("please enter email and password");
        }
    }

    return (
        <div className="logincard">

            <Card className="" >
                <div className="text-center" >
                    {(updatepassmsg && email.length <= 0) ? <small className="text-info" ><b>{updatepassmsg}</b></small> : ""}
                </div>

                <Card.Img src={rcmlogo} alt="Card image" className="rcmlogo" />

                <Card.Body>

                    <Form onSubmit={handleSubmit}>
                        <div className="m-3">
                            <div className="mt-2">
                                <label>Email</label>
                            </div>
                            <div>
                                <input type="text" name="email" onChange={handleChange} className="form-control" />
                            </div>
                        </div>
                        <div className="m-3">
                            <div>
                                <label>Password</label>
                            </div>
                            <div className="input-group">
                                <input type={passwordType} name="password" onChange={handleChange} className="form-control" />
                                <button className="input-group-text btn btn-outline-primary" type="button" onClick={togglePassword}>
                                    {passwordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3" >
                                <Button type="submit" style={{ backgroundColor: '#0187c4' }} className="m-3">Login</Button>
                            </div>
                            <div className="col-md-8 mt-4" >
                                <Link to="/resetpassword" className="link-text">Reset Your Password</Link>
                            </div>
                        </div>
                    </Form>

                </Card.Body>
            </Card>
        </div>
    )
}

export default Login;